<template>
  <v-dialog v-model="dialog" fullscreen>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="$permission('108')"
        small
        v-on="on"
        v-bind="attrs"
        @click="pushRouteName()"
        :disabled="!promotion.isReallyActive"
      >
        <v-icon>mdi-file-export</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>
          <strong>{{ promotion.title }}</strong>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container elevation="0">
        <v-card>
          <div class="pa-4">
            <span class="body-2">ID: {{ promotion.id_promo }}</span> <br />
            <span class="body-2">{{ $t("dateStart") }}: {{ dataInicio }}</span>
            <br />
            <span class="body-2">{{ $t("dateFinal") }}: {{ dataFinal }}</span>
          </div>
          <div class="ma-3">
            <v-row no-gutters class="d-flex align-center">
              <v-col
                cols="12"
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              >
                <v-select
                  v-model="exportOptions"
                  :items="items"
                  :label="$t('all')"
                  item-text="text"
                  item-value="value"
                  return-object
                  dense
                  filled
                  hide-details
                  solo-inverted
                ></v-select>
              </v-col>
              <div style="width: 100%;">
                <GroupExport class="my-3" />
                <div class="d-flex justify-end my-3">
                  <v-btn
                    class="info"
                    :block="$vuetify.breakpoint.smAndDown"
                    :disabled="loading"
                    small
                    @click="listAndExportTokens()"
                  >
                    <v-icon small v-if="exportDoc != ''" left>
                      mdi-file-export
                    </v-icon>
                    <span v-if="exportDoc == ''">
                      {{ $t("toFilter") }}
                    </span>
                    <span v-else>
                      {{ $t("exportTokens") }}
                    </span>
                  </v-btn>
                </div>
              </div>
            </v-row>
          </div>
        </v-card>
        <v-card>
          <div>
            <v-row class="px-3 justify-end">
              <v-col cols="12" md="4" sm="4" lg="3">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                  dense
                  solo-inverted
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <div>
            <v-data-table
              :headers="headers"
              :items="tokensInfos"
              :search="search"
              :footer-props="{
                'items-per-page-text': this.$t('rowsPerPage'),
              }"
            >
              <template v-slot:item.token="{ item }">
                <v-btn class="text-lowercase" @click="$copy(item.token)" small>
                  {{ item.token }}
                </v-btn>
              </template>

              <template v-slot:item.date_use="{ item }">
                <div v-if="item.date_use">
                  {{ item.date_use }}
                </div>
                <div v-else class="text-center">
                  ─
                </div>
              </template>

              <template v-slot:item.id_usuario="{ item }">
                <v-btn
                  v-if="item.id_usuario"
                  @click="$copy(item.id_usuario)"
                  small
                >
                  {{ item.id_usuario }}
                </v-btn>
                <div v-else class="text-center">
                  ─
                </div>
              </template>

              <template v-slot:item.nome="{ item }">
                <div v-if="item.nome" small>
                  {{ item.nome }}
                </div>
                <div v-else class="text-center">
                  ─
                </div>
              </template>

              <template v-slot:item.email="{ item }">
                <div v-if="item.email" small>
                  {{ item.email }}
                </div>
                <div v-else class="text-center">
                  ─
                </div>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import GroupExport from "@/components/common/filters/GroupExport.vue";

export default {
  name: "export-promotion-tokens",

  props: ["promotion"],

  components: {
    GroupExport,
  },

  data: () => ({
    loading: false,
    dialog: false,
    search: "",
    exportOptions: {},
    errorMsg: null,
    noDataFound: false,
    tokensInfos: [],
    promoInfos: [],
    dataInicio: "",
    dataFinal: "",
  }),

  computed: {
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },

    headers() {
      return [
        {
          text: "Token",
          value: "token",
          align: "center",
        },
        {
          text: this.$t("dateUse"),
          value: "date_use",
          align: "center",
        },
        {
          text: this.$t("idUser"),
          value: "id_usuario",
          align: "center",
        },
        {
          text: this.$t("name"),
          value: "nome",
          align: "center",
        },
        {
          text: this.$t("emailLabel"),
          value: "email",
          align: "center",
        },
      ];
    },

    items() {
      return [
        {
          text: this.$t("all"),
          value: "todos",
        },
        {
          text: this.$t("ransomed"),
          value: "resgatados",
        },
        {
          text: this.$t("notRansomed"),
          value: "nao resgatados",
        },
      ];
    },
  },

  mounted() {
    this.exportOptions = { text: this.$t("all"), value: "todos" };
  },

  watch: {
    dialog(val) {
      val && this.listAndExportTokens();
    },
  },

  methods: {
    closeDialog() {
      this.$router.go(-1);
      this.dialog = false;
      this.tokensInfos = [];
      this.exportOptions = { text: this.$t("all"), value: "todos" };
    },

    pushRouteName() {
      this.$router
        .push({
          name: "CollaboratorExportPromotionTokens",
        })
        .catch(() => {});
    },

    async listAndExportTokens() {
      this.loading = true;
      this.tokensInfos = [];
      try {
        const body = {
          id_promo: this.promotion.id_promo,
          rescue: this.exportOptions.value, // 'todos', 'resgatados', 'nao resgatados'
          export: this.exportDoc,
        };

        let response;

        if (this.exportDoc) {
          const extension = this.exportDoc;
          response = await this.$request.exportDoc(
            "/colab/promotions/listTokensByPromo",
            body,
            extension
          );
        } else {
          response = await this.$request.post(
            "/colab/promotions/listTokensByPromo",
            body
          );
        }

        if (!response.dados) {
          this.tokensInfos = [];
          this.loading = false;
          return;
        }
        this.tokensInfos = response.dados.tokens;
        this.promoInfos = response.dados.promo;
        this.dataInicio = new Date(
          this.promoInfos.data_inicio.replace(" ", "T")
        ).toLocaleString();
        this.dataFinal = new Date(
          this.promoInfos.data_final.replace(" ", "T")
        ).toLocaleString();
        this.tokensInfos.forEach((item) => {
          item.date_use
            ? (item.date_use = new Date(
                item.date_use.replace(" ", "T")
              ).toLocaleString())
            : null;
        });
      } catch (error) {
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
